import { render, staticRenderFns } from "./PartnerCertificationPopup.vue?vue&type=template&id=2ce5e8d8&scoped=true&"
import script from "./PartnerCertificationPopup.vue?vue&type=script&lang=js&"
export * from "./PartnerCertificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCertificationPopup.vue?vue&type=style&index=0&id=2ce5e8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5e8d8",
  null
  
)

export default component.exports